function backgroundColorMapper(colorName) {
    switch (colorName) {
        case "white":
            return "bg-white";
        case "black":
            return "bg-black";
        case "teal":
            return "bg-teal";
        case "teal-600":
            return "bg-teal-600";
        case "orange":
            return "bg-orange";
        case "orange-600":
            return "bg-orange-600";
        case "blue":
            return "bg-blue";
        case "blue-600":
            return "bg-blue-600";
        case "yellow":
            return "bg-yellow";
        case "purple":
            return "bg-purple";
        case "red":
            return "bg-red";
        case "green":
            return "bg-green";
        default:
            return "bg-transparant";
    }
}

function buttonColorMapper(colorName) {
    switch (colorName) {
        case "white":
            return "border-white text-white bg-transparant hover:bg-white hover:text-black";
        case "black":
            return "border-black bg-transparant hover:bg-black hover:text-white";
        case "teal":
            return "border-teal-600 bg-teal hover:border-teal hover:bg-teal-600 text-white";
        case "orange":
            return "border-orange-600 bg-orange hover:border-orange hover:bg-orange-600 text-white";
        case "blue":
            return "border-blue-600 bg-blue hover:border-blue hover:bg-blue-600 text-white";
        case "yellow":
            return "border-yellow bg-yellow hover:brightness-95 text-black";
        case "purple":
            return "border-purple bg-purple hover:brightness-95 text-white";
        case "red":
            return "border-red bg-red hover:brightness-95 text-white";
        case "green":
            return "border-green bg-green hover:brightness-95 text-white";
        default:
            return "border-transparant bg-transparant text-black";
    }
}

module.exports = {
    backgroundColorMapper,
    buttonColorMapper,
};
